import { type ReactNode } from 'react';

import { BaseModalType, useModalContext } from '@admin/organisms/BaseModal';
import { Button, type ButtonVariant } from '@common/atoms/Button';

interface Props {
    children: ReactNode;
    variant?: ButtonVariant;
    contextKey?: BaseModalType | string;
}

export const OpenModalButton = ({
    children,
    variant = 'filled-primary',
    contextKey = BaseModalType.Default,
    ...rest
}: Props) => {
    const { openModal } = useModalContext(contextKey);

    return (
        <Button variant={variant} onClick={openModal} {...rest}>
            {children}
        </Button>
    );
};
